<app-slider-item class="contact-cards-slider__item">
  <div class="contact-cards-slider__item-box">
    @if (photo) {
      <app-image [src]="photo" [border-radius]="'small'" [width]="330" [height]="380"></app-image>
    }
    <div class="contact-cards-slider__item-header">
      <h3 class="contact-cards-slider__item-title">{{ name }}</h3>
      {{ position }}
    </div>
    @if (phone || email) {
      <div class="contact-cards-slider__item-contact">
        @if (phone) {
          <a class="contact-cards-slider__item-contact-box" [href]="'tel:' + phone | phone">
            <app-icon [icon]="'phone'" [width]="16"></app-icon>
            {{ phone }}
          </a>
        }
        @if (email) {
          <a class="contact-cards-slider__item-contact-box" [href]="'mailto:' + email">
            <app-icon [icon]="'mail'" [width]="16"></app-icon>
            {{ email }}
          </a>
        }
      </div>
    }
  </div>
</app-slider-item>
